export enum EventSeverity {
  LOW = 0,
  MODERATE = 1,
  MAJOR = 2,
  CRITICAL = 3,
}

export const EVENT_SEVERITY_EXPLANATION = {
  [EventSeverity.LOW]:
    'Potential risk only, forward-looking plans, resolved issues, or financial announcements without immediate supply impact',
  [EventSeverity.MODERATE]:
    'Class III recall; regional shortage; warning letter that could escalate; price increase 2-10%',
  [EventSeverity.MAJOR]:
    'Class II recall; FDA shortage list; multi-state hospital impact; >10% price spike or prolonged rationing',
  [EventSeverity.CRITICAL]:
    'Class I recall; national shortage of life-support products; >50% U.S. supply lost; any event causing deaths or surgery cancellations',
};

export const EVENT_SEVERITY_NAME = {
  [EventSeverity.LOW]: 'Low',
  [EventSeverity.MODERATE]: 'Moderate',
  [EventSeverity.MAJOR]: 'Major',
  [EventSeverity.CRITICAL]: 'Critical',
};
